import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { Utils } from 'src/app/core/resources/utils';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Origin } from 'src/app/core/interfaces/origin';
import { Destination } from 'src/app/core/interfaces/destination';
import { buildMapInfoWindow } from "src/app/core/resources/map-info-window";
@Component({
  selector: 'app-cargo-route-visualization',
  templateUrl: './cargo-route-visualization.component.html',
  styleUrls: ['./cargo-route-visualization.component.scss']
})
export class CargoRouteVisualizationComponent implements OnInit {
  isDialog: boolean = false;
  cargo: Cargo;
  mapOptions: OptionsAutocomplete = {
    showMarkers: true,
    zoom: 12,
  };
  showMap: boolean = true;
  type: 'confirm' | 'visualization' = 'visualization';

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo, type: 'confirm' | 'visualization' },
    public dialogRef: MatDialogRef<CargoRouteVisualizationComponent>,
    public utils: Utils,
    public menuService: MenuServiceService
  ) { }

  ngOnInit() {
    this.checkDialogParams();
  }

  private checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.cargo = this.paramsDialog.cargo;
    } else this.cargo = this.menuService.cargo;
    if (this.paramsDialog && this.paramsDialog.type) this.type = this.paramsDialog.type;
  }

  setMapOptions() {
    if (!this.cargo) {
      this.showMap = false;
      return;
    }
    try {
      let path = [];
      const origin: Origin = this.utils.getNestedValue(this.cargo, 'cargoFeature.uploadDownload.origin');
      origin.addresses.forEach((address) => {
        let point = {
          key: address.address,
          lat: address.location.lat,
          lng: address.location.lng,
          icon: '/assets/svg/icons/tl_ico__pin_google_maps_trip_stop.svg',
          contentInfoWindow: buildMapInfoWindow({
            icon: 'fas fa-map-marker-alt',
            title: address.address,
            subtitle: 'Origen'
          }),
          showMarker: true
        };
        path.push(point);
      });
      const destinations: Destination[] = this.utils.getNestedValue(this.cargo, 'cargoFeature.uploadDownload.destination');
      destinations.forEach((destination) => {
        destination.addresses.forEach((address) => {
          let point = {
            key: address.address,
            lat: address.location.lat,
            lng: address.location.lng,
            icon: '/assets/svg/icons/tl_ico__pin_google_maps_trip_stop.svg',
            contentInfoWindow: buildMapInfoWindow({
              icon: 'fas fa-map-marker-alt',
              title: address.address,
              subtitle: 'Destino'
            }),
            showMarker: true
          };
          path.push(point);
        });
      });
      path.forEach((point, index) => point['labelIcon'] = `${index + 1}`);
      path[0]['setCenter'] = true;
      this.mapOptions['route'] = { 'route': { path, showPolyline: true } };
      this.mapOptions['polyline'] = { 'route': { path, showPolyline: true } };;
      this.mapOptions = { ...this.mapOptions };
    } catch (error) {
      this.showMap = false;
      return;
    }
  }

  saveAndContinue() {
    this.dialogRef.close({ state: true });
  }
}

